import { b2x } from '@b2x/react/src';
import classnames from 'classnames';
import React from 'react';

import { useAppContext, useAppStaticContext } from '../AppContext';

export interface PageProps extends b2x.PageProps {
  backgroundImage?: b2x.contentTypes.ImageContentSectionV1;
  children?: React.ReactNode;
  greyBackground?: boolean;
  headerCheckout?: boolean;
  hiddenFooter?: boolean;
  minimalFooter?: boolean;
  noPaddingBottom?: boolean;
  noPaddingTop?: boolean;
  transparentHeader?: boolean;
}

export const Page = ({
  backgroundImage,
  children,
  className,
  greyBackground = false,
  headerCheckout = false,
  hiddenFooter = false,
  minimalFooter = false,
  noPaddingBottom = false,
  noPaddingTop = false,
  transparentHeader = false,
  ...otherProps
}: PageProps) => {
  const { pageReady } = b2x.useAppContext();
  const { headerHeight } = useAppContext();
  const { setGreyBackgroundPage, setHeaderCheckout, setHiddenFooter, setMinimalFooter, setTransparentHeader } =
    useAppStaticContext();

  React.useEffect(() => {
    pageReady && setTransparentHeader(transparentHeader);
    pageReady && setMinimalFooter(minimalFooter);
    pageReady && setHiddenFooter(hiddenFooter);
    pageReady && setHeaderCheckout(headerCheckout);
    pageReady && setGreyBackgroundPage(greyBackground);
  }, [
    greyBackground,
    minimalFooter,
    headerCheckout,
    setHeaderCheckout,
    pageReady,
    setGreyBackgroundPage,
    setMinimalFooter,
    transparentHeader,
    setTransparentHeader,
    hiddenFooter,
    setHiddenFooter,
  ]);

  React.useEffect(() => {
    if (greyBackground) {
      document.body.classList.add('bg-lighter');
    } else {
      document.body.classList.remove('bg-lighter');
    }
  }, [greyBackground]);

  return (
    <b2x.Page {...otherProps} className={classnames(className, 'h-100')}>
      <div className="Page h-100 position-relative">
        {backgroundImage && (
          <div className="position-absolute h-100 w-100">
            <b2x.ImageAsBackgroundFromContentV1 {...backgroundImage} />
          </div>
        )}
        <div
          className={classnames(
            'position-relative h-100',
            'py-3 py-xl-5',
            { 'bg-lighter': greyBackground },
            { 'pt-0 pt-xl-0': noPaddingTop },
            { 'pb-0 pb-xl-0': noPaddingBottom }
          )}
          style={{
            marginBottom: transparentHeader && headerHeight !== undefined ? -headerHeight : undefined,
            top: transparentHeader && headerHeight !== undefined ? -headerHeight : undefined,
          }}
        >
          {children}
        </div>
      </div>
    </b2x.Page>
  );
};
